import React, { createContext, useContext } from 'react';
import type { UvInsertCartLineItem } from '@shared/view/uv-inserts/build-cart-line-item';

type FlowBridgeContextType = {
  /**
   * Fires when the UV inserts journey completes (add to bag).
   * Receives the MVVM-built cart line item (null when no visualiser config was active,
   * e.g. user skipped all inserts). Calls outer PageContext.goToPage('FINISHED').
   */
  onFinish: (uvInsertCartItemBuilder: (() => UvInsertCartLineItem | null) | null) => void;
  /** Fires when user navigates back from addPersonalTouch. Calls outer PageContext.goToPage('firstPage'). */
  onBack: () => void;
  /** Closes the gift wrap modal dialog. */
  onClose: (e?: React.MouseEvent) => void;
};

export const FlowBridgeContext = createContext<FlowBridgeContextType>({
  onFinish: () => {},
  onBack: () => {},
  onClose: () => {},
});

/**
 * Returns the flow bridge context, providing cross-boundary callbacks from
 * within the TanStack Router tree to the outer gift-wrap PageContext.
 * @returns {FlowBridgeContextType} The flow bridge context value.
 */
export function useFlowBridge(): FlowBridgeContextType {
  return useContext(FlowBridgeContext);
}
